export const getDevice = () => {
  if (typeof navigator === 'undefined') return false

  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'MOBILE' : 'DESKTOP'
}
